export type Product = {
  id: string;
  rank: number;
  badge: string;
  productName: string;
  merchant: string;
  price: string;
  priceValue: number;
  priceTier: "value" | "mid" | "premium";
  bestFor: string;
  features: string[];
  editorNote: string;
  imageUrl: string;
  imageAlt: string;
  detailImages: string[];
  merchantUrl: string;
  affiliateUrl: string;
  policyStatus: "product_candidate" | "policy_candidate" | "launch_candidate";
  imageStatus: "self_generated_placeholder" | "pending" | "feed_allowed" | "merchant_creative_allowed" | "blocked";
  trackingMerchant: string;
  trackingProduct: string;
  laptop: string;
  closure: string;
  travelDetail: string;
};

export const products: Product[] = [
  {
    id: "beis-work-tote-black",
    rank: 1,
    badge: "Best overall",
    productName: "The Work Tote",
    merchant: "BÉIS",
    price: "$148",
    priceValue: 148,
    priceTier: "mid",
    bestFor: "structured daily office carry",
    features: ["Laptop-friendly work tote", "Interior organization pockets", "Trolley pass-through for travel days"],
    editorNote: "The cleanest first pick for office days: polished enough for meetings, practical enough for commuting, and priced for the main test band.",
    imageUrl: "/images/product-01-black-work-tote.webp",
    imageAlt: "Black structured work tote with laptop-friendly organization",
    detailImages: ["/images/detail-laptop-fit.webp", "/images/detail-structured-base.webp"],
    affiliateUrl: "",
    merchantUrl: "https://beistravel.com/products/the-work-tote-in-black",
    policyStatus: "policy_candidate",
    imageStatus: "self_generated_placeholder",
    trackingMerchant: "beis",
    trackingProduct: "the_work_tote",
    laptop: "Laptop-friendly",
    closure: "Open top",
    travelDetail: "Trolley pass-through",
  },
  {
    id: "quince-italian-leather-triple-compartment-work-tote",
    rank: 2,
    badge: "Best leather value",
    productName: "Italian Leather Triple Compartment Work Tote",
    merchant: "Quince",
    price: "$174",
    priceValue: 174,
    priceTier: "mid",
    bestFor: "leather organization under $200",
    features: ["Top-grain leather positioning", "Triple compartment organization", "Laptop sleeve for office commuting"],
    editorNote: "A strong value anchor for shoppers who want leather, a polished profile, and built-in organization without moving into premium pricing.",
    imageUrl: "/images/product-02-cognac-leather-tote.webp",
    imageAlt: "Cognac leather work tote with clean office-ready shape",
    detailImages: ["/images/detail-interior-pockets.webp", "/images/detail-zip-closure.webp"],
    affiliateUrl: "https://sovrn.co/bxvednj",
    merchantUrl: "https://www.quince.com/women/leather-work-tote?color=black&gender=women",
    policyStatus: "launch_candidate",
    imageStatus: "self_generated_placeholder",
    trackingMerchant: "quince",
    trackingProduct: "italian_leather_triple_compartment_work_tote",
    laptop: "Sleeve listed",
    closure: "Zipper",
    travelDetail: "Structured compartments",
  },
  {
    id: "beis-commuter-tote-black",
    rank: 3,
    badge: "Best under $150",
    productName: "The Commuter Tote",
    merchant: "BÉIS",
    price: "$138",
    priceValue: 138,
    priceTier: "value",
    bestFor: "lightweight commuter organization",
    features: ["Commuter-friendly work shape", "Travel-ready feature set", "Lower entry price for first-click testing"],
    editorNote: "The sharper under-$150 pick for shoppers who want a work tote feel without jumping into leather or premium pricing.",
    imageUrl: "/images/product-03-commuter-tote.webp",
    imageAlt: "Black commuter tote for office and work travel",
    detailImages: ["/images/detail-trolley-sleeve.webp", "/images/detail-laptop-fit.webp"],
    affiliateUrl: "",
    merchantUrl: "https://beistravel.com/products/the-commuter-tote-in-black",
    policyStatus: "policy_candidate",
    imageStatus: "self_generated_placeholder",
    trackingMerchant: "beis",
    trackingProduct: "the_commuter_tote",
    laptop: "Work carry",
    closure: "Zip detail",
    travelDetail: "Commute friendly",
  },
  {
    id: "freja-linnea-tote-latte",
    rank: 4,
    badge: "Best quiet polish",
    productName: "Linnea Tote",
    merchant: "Freja",
    price: "$318",
    priceValue: 318,
    priceTier: "premium",
    bestFor: "low-logo 13-14 inch laptop carry",
    features: ["Fits 13-14 inch laptops", "Center zip divider and pockets", "Firm base that stands upright"],
    editorNote: "The most on-theme quiet-polish candidate: structured, low-logo, organized, and visually aligned with the guide's office-ready point of view.",
    imageUrl: "/images/product-04-green-structured-tote.webp",
    imageAlt: "Deep green structured work tote with quiet professional styling",
    detailImages: ["/images/detail-shoulder-drop.webp", "/images/detail-structured-base.webp"],
    affiliateUrl: "",
    merchantUrl: "https://frejanyc.com/products/linnea-tote-latte",
    policyStatus: "product_candidate",
    imageStatus: "self_generated_placeholder",
    trackingMerchant: "freja",
    trackingProduct: "linnea_tote",
    laptop: "13-14 inch",
    closure: "Center zip",
    travelDetail: "Firm base",
  },
  {
    id: "cuyana-system-tote-13-inch-black",
    rank: 5,
    badge: "Best modular leather",
    productName: "System Tote 13-inch",
    merchant: "Cuyana",
    price: "$358",
    priceValue: 358,
    priceTier: "premium",
    bestFor: "customizable leather work setup",
    features: ["Leather inside and out", "Softly structured silhouette", "Interior snaps for organization add-ons"],
    editorNote: "A premium trust anchor for shoppers who want a leather tote that can become more organized over time with modular accessories.",
    imageUrl: "/images/product-05-beige-modular-tote.webp",
    imageAlt: "Beige modular work tote with laptop sleeve and interior organization",
    detailImages: ["/images/detail-interior-pockets.webp", "/images/detail-zip-closure.webp"],
    affiliateUrl: "",
    merchantUrl: "https://cuyana.com/products/system-tote-13-inch-v2",
    policyStatus: "product_candidate",
    imageStatus: "self_generated_placeholder",
    trackingMerchant: "cuyana",
    trackingProduct: "system_tote_13_inch",
    laptop: "13 inch",
    closure: "Open top",
    travelDetail: "Modular interior",
  },
  {
    id: "beis-large-work-tote-black",
    rank: 6,
    badge: "Best larger carry",
    productName: "The Large Work Tote",
    merchant: "BÉIS",
    price: "$168",
    priceValue: 168,
    priceTier: "mid",
    bestFor: "larger laptop and extra workday capacity",
    features: ["Larger work tote capacity", "Multiple compartments", "Work-to-travel utility"],
    editorNote: "The safer pick for users who carry more than a laptop: files, pouches, chargers, and the extra things that make a commute real.",
    imageUrl: "/images/product-06-navy-large-tote.webp",
    imageAlt: "Navy large work tote with structured office profile",
    detailImages: ["/images/detail-trolley-sleeve.webp", "/images/detail-shoulder-drop.webp"],
    affiliateUrl: "",
    merchantUrl: "https://beistravel.com/products/the-large-work-tote-in-black",
    policyStatus: "policy_candidate",
    imageStatus: "self_generated_placeholder",
    trackingMerchant: "beis",
    trackingProduct: "the_large_work_tote",
    laptop: "Larger carry",
    closure: "Zipper",
    travelDetail: "Work-to-travel",
  },
];

export const criteria = [
  {
    id: "structure",
    label: "Structure",
    description: "Holds its shape enough for work settings.",
  },
  {
    id: "laptop-fit",
    label: "Laptop fit",
    description: "Checked for laptop and tablet-friendly carry.",
  },
  {
    id: "organization",
    label: "Organization",
    description: "Pockets, dividers, closures, and useful interior logic.",
  },
  {
    id: "commute-comfort",
    label: "Commute comfort",
    description: "Shoulder drop, weight, and travel-day details.",
  },
  {
    id: "quiet-style",
    label: "Quiet style",
    description: "Low-logo, polished, office-ready design.",
  },
  {
    id: "price-sanity",
    label: "Price sanity",
    description: "Selected across practical price points.",
  },
];
